var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 76,
    viewBox: "0 0 81 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_702_190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0214 29.5436C50.4747 26.3701 50.9281 23.4989 51.3815 20.4765C51.8348 17.6052 52.8927 14.5828 52.2882 11.5604C51.5326 7.93357 50.9281 3.39999 48.0568 0.830958C47.1501 0.22648 44.1277 -0.0757589 41.5587 0.22648C40.8031 0.377599 40.5009 0.830958 40.5009 1.58655C40.8031 4.91118 40.9542 8.23581 41.2565 11.5604C41.4076 13.8272 41.1053 15.7918 40.0475 17.9075C36.874 23.8011 33.7005 29.5436 30.6781 35.4373C29.4691 37.7041 28.2602 39.6686 26.1445 41.1798C25.6912 41.4821 25.54 42.0866 25.54 42.691V71.5548C25.54 72.0082 26.2956 72.3104 26.5979 72.6127C27.3535 73.2172 27.8068 73.6705 28.7135 74.1239C30.527 75.484 32.3404 75.484 34.4561 75.484H66.7956C73.1427 75.484 74.3516 74.1239 73.7471 68.0791C73.4449 66.719 70.8759 66.4168 70.2714 65.2078C71.027 65.0567 74.9561 64.3011 75.8628 64.15C78.1296 63.6966 78.7341 57.0474 77.374 55.9895C76.9206 55.234 75.2583 54.6295 74.6538 53.8739C75.5606 53.5716 76.3162 53.2694 77.0718 53.1183C79.4897 52.3627 81.0009 52.5138 81.0009 48.2825C81.0009 44.0511 80.0942 44.0511 78.1296 42.8422C77.374 42.3888 76.6184 41.9354 75.8628 41.4821C76.165 41.1798 76.4673 41.0287 76.6184 40.8776C77.0718 40.5754 77.374 40.2731 77.8274 39.9709C79.943 38.3086 80.2453 38.9131 79.943 33.775C79.1874 31.5082 76.7695 29.8459 74.3516 29.8459H51.3815C50.9281 29.5436 50.4747 29.5436 50.0214 29.5436Z",
    fill: "#00755F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1922 73.9728H3.77799C1.66231 73.9728 0 72.3105 0 70.1948V43.5978C0 41.4821 1.66231 39.8198 3.77799 39.8198H19.041C21.1567 39.8198 22.819 41.4821 22.819 43.5978V70.3459C22.9702 72.3105 21.1567 73.9728 19.1922 73.9728Z",
    fill: "#00755F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_702_190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 75.3784,
    fill: "white",
    transform: "translate(0 0.105469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumb);
export default __webpack_public_path__ + "static/media/thumb.7e39604ea8fb8ad1c1c084e1c0984ab0.svg";
export { ForwardRef as ReactComponent };